<div
  class="scroll-container"
  infiniteScroll
  [infiniteScrollContainer]="'.mat-drawer-content'"
  [fromRoot]="true"
  [scrollWindow]="true"
  [infiniteScrollDistance]="scrollDistance"
  [infiniteScrollUpDistance]="scrollUpDistance"
  [infiniteScrollThrottle]="throttle"
  (scrolled)="onScrollDown($event)"
>
  <div class="container">
    <div class="header">
      <div class="header-left">
        <app-search-rounded-border
          placeholder="Busque por Nome"
          (onInputText)="handleSearchText($event)"
        ></app-search-rounded-border>
      </div>
      <div class="header-right">
        <app-classroom-select
          [year]="yearFilter"
          [initialIds]="classroomsFilter"
          (selectEvent)="handleSelectClassroom($event)"
          placeholder="Turma"
        ></app-classroom-select>
        <div
          class="authorization-status-filter"
          *ngIf="canLoadAuthorizationStatusFilter"
        >
          <app-news-authorization-status-filter
            [initialList]="statusFilter"
            [hasAuthorization]="newsHasAuthorization"
            (onSelectOption)="handleSelectAuthorizationStatus($event)"
          ></app-news-authorization-status-filter>
        </div>
      </div>
    </div>
    <div class="list-content">
      <div class="no-eligibles-container" *ngIf="eligibleUsers.length <= 0">
        <div class="no-eligibles-content">
          <div class="no-eligibles-image-container">
            <img
              class="no-eligibles-image"
              src="../../../../../assets/images/no-results.svg"
            />
          </div>
          <div class="no-eligibles-text-container">
            <h2 class="no-eligibles-text-head">Nenhum resultado encontrado</h2>
            <p class="no-eligibles-text-article">
              Busque por algum outro termo ou utilize um filtro diferente
            </p>
          </div>
        </div>
      </div>
      <div *ngFor="let item of eligibleUsers; index as i">
        <app-news-engagement-item
          [newsHasAuthorization]="newsHasAuthorization"
          [eligibleUser]="item"
          [isStudentProfileEligible]="isStudentProfileEligible"
          [isResponsibleProfileEligible]="isResponsibleProfileEligible"
        ></app-news-engagement-item>
        <div class="horizontal-line" *ngIf="i < countRegister! - 1"></div>
      </div>
    </div>
  </div>
</div>
